import { render } from "./TimesheetCommentModal.vue?vue&type=template&id=21c679b4&scoped=true"
import script from "./TimesheetCommentModal.vue?vue&type=script&lang=js"
export * from "./TimesheetCommentModal.vue?vue&type=script&lang=js"

import "./TimesheetCommentModal.vue?vue&type=style&index=0&id=21c679b4&lang=scss&scoped=true"

import exportComponent from "/Users/mapat/Projects/orange-hrm/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c679b4"]])

export default __exports__